import { mdiCarBattery, mdiMapMarker, mdiTapeMeasure, mdiThermometerLines } from "@mdi/js";

export const ParameterIcons = {
    distance: mdiTapeMeasure,
    temperature: mdiThermometerLines,
    battery: mdiCarBattery,
    default: mdiMapMarker,
}